import Cookies from 'js-cookie'

class Dismissible {
  constructor(button) {
    const target = document.querySelector(
      button.getAttribute('data-dismiss-target')
    )
    const showElement = document.querySelector(
      button.getAttribute('data-dismiss-show')
    )
    const setCookie = button.getAttribute('data-dismiss-set-cookie')
    const removeCookie = button.getAttribute('data-dismiss-remove-cookie')

    if (target) {
      button.addEventListener('click', e => {
        e.preventDefault()
        this.dismissTarget(target, showElement, {
          setCookie: setCookie,
          removeCookie: removeCookie,
        })
      })
    }
  }

  dismissTarget(target, showElement, options) {
    target.classList.add('u-hidden')

    if (options.setCookie) {
      Cookies.set(options.setCookie, true, { expires: 3650 })
    }

    if (options.removeCookie) {
      Cookies.remove(options.removeCookie)
    }

    if (showElement) {
      showElement.classList.remove('u-hidden')
    }
  }
}

document.addEventListener('turbolinks:load', () => {
  const dismissButtons = document.querySelectorAll('.js-dismissible')

  dismissButtons.forEach(button => {
    new Dismissible(button)
  })
})
